import React from 'react';
import '../../css/login.css';
import env from '../../env';

class AcknowledgementModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalVisible: false,
        };
        this.handleAgree = this.handleAgree.bind(this);
    }

    componentDidMount() {
        // Access the environment variable directly from your imported 'env' object
        const isIL4Toggle = env.IS_IL4
        if (isIL4Toggle === "true") {
            this.setState({ isModalVisible: true }, () => {
                console.log('Modal visibility state:', this.state.isModalVisible);
            });
        } else {
            this.setState({ isModalVisible: false }, () => {
                console.log('Modal visibility state:', this.state.isModalVisible);
            });
        }
    }

    handleAgree() {
        this.setState({ isModalVisible: false });
        if (this.props.onAgree) {
            this.props.onAgree();
        }
    }

    render() {
        if (!this.state.isModalVisible) {
            return null;
        }

            return (
                <div className="acknowledgement-modal-overlay">
                    <div className="acknowledgement-modal-content">
                        <div className="acknowledgement-modal-body">
                            <h3>Standard Mandatory DoD Notice and Consent</h3>
                            <h5>
                                You are accessing a U.S. Government (USG) Information System (IS) that is provided for USG-authorized use only.
                            </h5><br />
                            <p> By using this IS (which includes any device attached to this IS), you consent to the following conditions:</p>
                            <p>
                                1. The USG routinely intercepts and monitors communications on this IS for purposes including, but not limited to,
                                penetration testing, COMSEC monitoring, network operations and defense, personnel misconduct (PM), law enforcement (LE),
                                and counterintelligence (CI) investigations.
                            </p>
                            <p>
                                2. At any time, the USG may inspect and seize data stored on this IS.
                            </p>
                            <p>
                                3. Communications using, or data stored on, this IS are not private, are subject to routine monitoring, interception,
                                and search, and may be disclosed or used for any USG authorized purpose.
                            </p>
                            <p>
                                4. This IS includes security measures (e.g., authentication and access controls) to protect USG interests – not for your
                                personal benefit or privacy.
                            </p>
                            <p>
                                5. Notwithstanding the above, using this IS does not constitute consent to PM, LE or CI investigative searching or monitoring
                                of the content of privileged communications, or work product, related to personal representation or services by attorneys,
                                psychotherapists, or clergy, and their assistants. Such communications and work product are private and confidential.
                                See User Agreement for details.
                            </p>
                        </div>
                        <div className="acknowledgement-modal-footer">
                            <button
                                onClick={this.handleAgree}
                                className="wdc-btn wdc-btn-primary"
                            >
                                I Agree
                            </button>
                        </div>
                    </div>
                </div>
            );
    }
}

export default AcknowledgementModal;
